import React, { useState } from 'react'
import { WidgetContent, TextField, Select } from '@duik/it'
import CreateNewModal from '../../UI/CreateNewModal'
import { ModalButton } from '../../UI/ModalButton'
import { Checkbox, Tabs, TabItem } from '@duik/it'
import moment from 'moment'

const AssignTruck = ({
  truckDetail,
  drivers,
  handleAssignTruckModalClose,
  assignDriver,
  dispatch,
  dispatchDetail
}) => {
  const assignedTrucks = dispatchDetail.filter(item => item.status !== 'declined')
  const [selectedDrivers, setSelectedDrivers] = useState([...assignedTrucks])

  const handleSaveButtonClick = () => {
    assignDriver(truckDetail, selectedDrivers)
    handleAssignTruckModalClose(true)
  }

  const handleDriverSelect = driver => {
    const isSelectedIndex = selectedDrivers.findIndex(item => item._id === driver._id)
    if (isSelectedIndex > -1) {
      selectedDrivers.splice(isSelectedIndex, 1)
      setSelectedDrivers([...selectedDrivers])
    } else {
      setSelectedDrivers([...selectedDrivers, driver])
    }
  }

  return (
    <CreateNewModal
      title="Assign Trucks"
      bannerText={`${assignedTrucks.length}/${dispatch.trucksRequired} Trucks Assigned`}
      handleCloseModal={handleAssignTruckModalClose}
    >
      <form>
        <WidgetContent
          style={{
            height: '355px',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            padding: 0,
            overflowY: 'scroll',
            overflowX: 'hidden'
          }}
          id="dispatch-form"
        >
          <div style={{ width: '100%' }}>
            <Tabs sm>
              <TabItem className="active">
                {moment(truckDetail.startDateTime).format('HH:mm')}
              </TabItem>
            </Tabs>
            <div style={{ padding: '0 30px' }}>
              <div
                style={{
                  marginTop: '16px',
                  display: 'flex',
                  justifyContent: 'space-between'
                }}
              >
                <span style={{ fontSize: '12px', color: '#9EA0A5' }}>
                  TRUCKS - {truckDetail.pickUpSite} to {truckDetail.dropOffSite}
                </span>
              </div>
              <div
                style={{
                  marginTop: '8px',
                  height: '200px',
                  overflowY: 'scroll',
                  border: '1px solid #D8DCE6',
                  borderRadius: '4px'
                }}
              >
                <table style={{ width: '100%', padding: '10px 16px' }}>
                  <tbody>
                    {selectedDrivers.map((item, i) => (
                      <tr style={{ height: '40px' }} key={i}>
                        <td>
                          <span>
                            {item.driverName
                              ? item.driverName
                              : item.firstName
                              ? item.firstName
                              : item.phoneNumber}{' '}
                            {item.lastName && !item.driverName && item.lastName}
                          </span>
                        </td>
                        <td>
                          <span>{item.truckType && item.truckType}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div
                style={{
                  paddingTop: '16px',
                  display: 'flex',
                  justifyContent: 'space-between'
                }}
              >
                <div style={{ width: '322px' }}>
                  <TextField
                    className="threeQuarterWidthInputBox materials optionsFullWidth"
                    label=""
                    name="driverSerach"
                    // onChange={handleChange}
                    // onBlur={handleBlur}
                    // value={values.driverSearch}
                    placeholder="Search for a driver"
                  />
                </div>
                <div style={{ width: '134px' }}>
                  <Select
                    style={{ width: '134px' }}
                    activeOption={[{ value: '', label: '' }]}
                    label=""
                    options={[{ value: 'All', label: 'All' }]}
                    name="driverFilter"
                    menuPosition="bottom-left"
                    onOptionClick={e => console.log(e)}
                    placeholder="All"
                  />
                </div>
              </div>

              <div
                style={{
                  marginTop: '16px',
                  height: '200px',
                  overflowY: 'scroll',
                  border: '1px solid #D8DCE6',
                  borderRadius: '4px'
                }}
              >
                <table style={{ width: '100%', padding: '10px 16px' }}>
                  <tbody>
                    {drivers.map((item, i) => (
                      <tr style={{ height: '40px' }} key={i}>
                        <td>
                          <Checkbox
                            onChange={() => handleDriverSelect(item)}
                            style={{ color: '#34AA44' }}
                            checked={selectedDrivers.find(
                              driver => driver.driverPhoneNumber === item.phoneNumber
                            )}
                            disabled={selectedDrivers.find(
                              driver => driver.driverPhoneNumber === item.phoneNumber
                            )}
                          />
                        </td>
                        <td>
                          <span>
                            {item.firstName} {item.lastName}
                          </span>
                        </td>
                        <td>
                          <span>{item.truckType}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </WidgetContent>
        <div style={{ display: 'flex' }}>
          <WidgetContent
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              border: 'none',
              width: '482px'
            }}
          >
            <div style={{ width: '83px' }}>
              <ModalButton
                buttonStyle="tertiary"
                name="Cancel"
                onClick={handleAssignTruckModalClose}
              />
            </div>
            <div style={{ width: '83px' }}>
              <ModalButton
                success
                // disabled={isSubmitting}
                name="Save"
                onClick={handleSaveButtonClick}
              />
            </div>
          </WidgetContent>
        </div>
      </form>
    </CreateNewModal>
  )
}

export default AssignTruck
